import type {ReactAction} from '@netx/core/bootstrap';
import {faTimes} from '@netx/core-icons';
import {UploadActionLabel} from '../locales';
import type {AnyUppyFile} from '../types';

export const uploadBuilderActionRemoveFileIcon = faTimes;
export const uploadBuilderActionRemoveFileLabel = UploadActionLabel.REMOVE;

export type UploadBuilderActionRemoveFileParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (file: AnyUppyFile) => void;
};

/**
 *
 * @param params
 * @returns Action
 */
export const uploadBuilderActionRemoveFile = (
	file: AnyUppyFile,
	{cb, ...params}: UploadBuilderActionRemoveFileParams,
): ReactAction => ({
	name: 'upload-builder-remove-file',
	cb: () => cb(file),
	icon: uploadBuilderActionRemoveFileIcon,
	get label() {
		return uploadBuilderActionRemoveFileLabel;
	},
	...params,
});

export default uploadBuilderActionRemoveFile;
